import { sectionNames } from "@saleor/intl";
import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, Routes, useLocation, useParams } from "react-router-dom";

import { WindowTitle } from "../components/WindowTitle";
import {
  ShippingZonesListUrlQueryParams,
  ShippingZoneUrlQueryParams
} from "./urls";
import LocationRate from "./views/LocationRate";
import ShippingZoneCreate from "./views/ShippingZoneCreate";
import ShippingZoneDetailsComponent from "./views/ShippingZoneDetails";
import ShippingZonesListComponent from "./views/ShippingZonesList";

const ShippingZonesList: React.FC = () => {
  const location = useLocation();
  const qs = parseQs(location.search.substring(1));
  const params: ShippingZonesListUrlQueryParams = qs;
  return <ShippingZonesListComponent params={params} />;
};

const ShippingZoneDetails: React.FC = () => {
  const location = useLocation();
  const { id } = useParams();
  const qs = parseQs(location.search.substring(1));
  const params: ShippingZoneUrlQueryParams = qs;
  return (
    <ShippingZoneDetailsComponent id={decodeURIComponent(id)} params={params} />
  );
};

const ShippingZoneLocationPage: React.FC = () => {
  const location = useLocation();
  const { shippingZoneId } = useParams();
  const qs = parseQs(location.search.substring(1));
  const params: ShippingZoneUrlQueryParams = qs;
  return (
    <LocationRate
      shippingZoneId={decodeURIComponent(shippingZoneId)}
      params={params}
    />
  );
};

const ShippingZoneLocationEditPage: React.FC = () => {
  const location = useLocation();
  const { shippingZoneId, locationId } = useParams();
  const qs = parseQs(location.search.substring(1));
  const params: ShippingZoneUrlQueryParams = qs;
  return (
    <LocationRate
      shippingZoneId={decodeURIComponent(shippingZoneId)}
      locationId={decodeURIComponent(locationId)}
      params={params}
    />
  );
};

export const ShippingRouter: React.FC = () => {
  const intl = useIntl();

  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.shipping)} />
      <Routes>
        <Route path={""} element={<ShippingZonesList />} />
        <Route path={"add"} element={<ShippingZoneCreate />} />
        <Route
          path={":shippingZoneId/location/:locationId"}
          element={<ShippingZoneLocationEditPage />}
        />
        <Route
          path={":shippingZoneId/location"}
          element={<ShippingZoneLocationPage />}
        />
        <Route path={":id"} element={<ShippingZoneDetails />} />
      </Routes>
    </>
  );
};
export default ShippingRouter;
